// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__ydkOh","menuItem":"styles_menuItem__ub1W1","menuItemActive":"styles_menuItemActive__l0G8B"};